import { GameDrawerBase } from './gameDrawer.base';

export class GameDrawerMobile extends GameDrawerBase {}
